import React, { useState } from 'react';
import { useFetchOrders } from 'hooks/useFetchOrders';
import { OrderListTable } from 'components/OrderListTable/OrderListTable';
import { BillingCompanyListTable } from 'components/OrderListTable/BillingCompanyListTable';
import { Loader } from 'components/Loader/Loader';
import { CalendarFetch } from 'components/OrderListTable/CalendarFetch/CalendarFetch';
import { ReqEnum } from 'const/requestStatus';
import dayjs from 'dayjs';
import { OrderSearchStatus, OrderStatus } from 'types/orderTypes';
import { groupBy } from 'components/OrderListTable/utils/groupBy';
import { ButtonComponent } from '../../ReusableComponents/Button/ButtonComponent';
import { Helmet } from 'react-helmet';

export function BillingReportComposition() {
  const [toggleByComapny, setToggleByComapny] = useState(false);
  const [statusReq, setStatusReq] = useState<OrderSearchStatus>(
    OrderSearchStatus.Done
  );
  const [startDate, setStartDate] = useState(dayjs(new Date()));
  const [endDate, setEndDate] = useState(dayjs(new Date()));

  const fetchValues = values => {
    const { startDate, endDate, statusReq } = values;
    setStartDate(startDate);
    setEndDate(endDate);
    setStatusReq(statusReq);
  };

  const [orders, fetchStatus] = useFetchOrders(statusReq, startDate, endDate);

  const totalCount = orders => (orders ? orders.length : 0);

  const totalParcels = orders =>
    orders ? orders.reduce((sum, order) => sum + order.packagesNumber, 0) : 0;

  const ordersByPickupEmail =
    orders && fetchStatus === ReqEnum.SUCCESS && groupBy(orders, 'pickupEmail');

  const ordersByPickupEmailArray: any = Object.entries(ordersByPickupEmail);

  return (
    <div>
      <Helmet>
        <title>Reports - Billing</title>
      </Helmet>
      <CalendarFetch fetchValues={fetchValues} />
      {fetchStatus === 'REQUEST::PENDING' && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Loader type="spinner" size="large" />
        </div>
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginRight: '200px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <p>
            <em>Total orders from fetch:</em> <span>{totalCount(orders)}</span>
          </p>
          <p>
            <em>Total parcels from fetch:</em>{' '}
            <span>{totalParcels(orders)}</span>
          </p>
          <ButtonComponent onClick={() => setToggleByComapny(!toggleByComapny)}>
            {toggleByComapny ? 'View by all' : 'View by company'}
          </ButtonComponent>
        </div>
      </div>
      {toggleByComapny ? (
        ordersByPickupEmailArray.map((ordersByCompanyOrders, index) => {
          const csvName = ordersByCompanyOrders[0]
            ? `${ordersByCompanyOrders[0]}-${dayjs(startDate).format(
                'MM-DD'
              )}-${dayjs(endDate).format('MM-DD')}.csv`
            : 'data.csv';

          const deliveredOrders = ordersByCompanyOrders[1].filter(
            order => order.status !== OrderStatus.Canceled
          );

          return (
            <React.Fragment key={index}>
              <div
                style={{
                  paddingLeft: '10px',
                  fontWeight: 500,
                  fontSize: '2rem',
                }}
              >
                Company:
                {ordersByCompanyOrders[1][0] &&
                  ordersByCompanyOrders[1][0].pickupName}
              </div>
              <div
                style={{
                  paddingLeft: '10px',
                  fontWeight: 500,
                  fontSize: '1.5rem',
                }}
              >
                Email: {ordersByCompanyOrders[0]}
              </div>
              <BillingCompanyListTable
                orders={deliveredOrders}
                fetchStatus={fetchStatus}
                csvName={csvName}
              />
            </React.Fragment>
          );
        })
      ) : (
        <OrderListTable
          fetchStatus={fetchStatus}
          orders={orders ? orders : []}
        />
      )}
    </div>
  );
}
